window.i18n = {
  timezone: { allTimes: "All times", title: "Time zone", eventTime: "Event time", userTime: "Your time", selectDisplay: "Select time display" },
  showMore: "Show more",
  common: {
    close: "Close",
    cancel: "Cancel",
    skip: "Skip",
    all: "All",
    favorites: "Favorites",
    favorite: "Favorite",
    toggleFavorite: "Toggle favorite",
    clearSearch: "Clear search",
    searchPlaceholder: "Search...",
    noDataAvailable: "No data available",
    unknown: "Unknown",
    comingSoon: "Coming soon",
    expand: "Expand",
    moreInfo: "More info",
    live: "Live",
    tbd: "TBD",
    qrCode: "QR code",
    until: "until",
  },
  header: { menu: "Menu" },
  map: {
    loadError: "Map could not be loaded.<br>Please try refreshing the page.",
    privacy: "Privacy",
    terms: "Terms",
    openHome: "Open Eventhub home page",
  },
  controls: {
    resetNorth: "Reset bearing to north",
    emergencyCall: "Emergency call",
    toggle3d: "Toggle 3D view",
    recenter: "Center on my location",
    reload: "Reload site",
    toggleCourseSelector: "Toggle course selector",
    toggleCrowdCloud: "Toggle CrowdCloud",
    levels: "Select level",
  },
  routing: {
    car: "Car",
    walk: "Walk",
    googleMaps: "Google Maps",
    showRoute: "Show route",
    endRoute: "End route",
    routeComplete: "Route complete",
  },
  wayfinding: {
    offsiteTitle: "You're currently offsite",
    offsiteBody: "Wayfinding is only available when you're onsite.",
    shareLocation: "Share my location",
    presentedBy: "Presented by",
    noLocationTitle: "We can't find your location",
    locating: "We're still determining your location — please allow location sharing if asked, or try again in a moment.",
    locatingShort: "Locating…",
    tryAgain: "Try again",
    reloadPage: "Reload page",
    stillBlocked: "Location access is still blocked — follow the steps above, then reload the page.",
    stepsApp: "Allow location access for this app in your phone's Settings, then try again.",
    stepsTitle: "How to allow location on your phone:",
    stepsIosSystem: "Open Settings › Privacy & Security › Location Services and turn Location Services on.",
    stepsIosSite: "In the same list, tap Safari Websites (or your browser) and choose “While Using the App” or “Ask Next Time”.",
    stepsAndroidSystem: "Open Settings › Location and turn Location on.",
    stepsAndroidSite: "In Chrome, tap the three dots ⋮ › Settings › Site settings › Location and allow this site (or remove it from “Blocked”).",
    stepsThenRetry: "Then come back here and tap “Reload page”.",
    routeUnavailableTitle: "We can't show a route right now",
    routeUnavailableBody: "The route couldn't be calculated. Please try again in a moment.",
  },
  consent: {
    title: "We need your consent",
    body: "To view this content, please accept third-party marketing cookies.",
    settings: "Cookie Settings",
  },
  livestream: {
    configError: "Livestream configuration error.",
    unavailable: "Livestream player unavailable.",
    geoBlocked: "This stream is not available in your region.",
    playerError: "Livestream player error.",
  },
  notifications: {
    showAll: "show all",
    hideAll: "hide all",
  },
  emergency: {
    title: "Emergency",
    callNow: "Call now",
  },
  units: {
    min: "min",
    hour: "h",
  },
  sidebar: {
    players: "Players",
    more: "More",
    fullscreen_teaser: "For the best experience, click here to open the map.",
    information: "Information",
    playerSearch: "Player search",
    practice: "Practice Round",
    leaderboard: "Leaderboard",
    highlights: "Highlights",
    fullscreenIn: "Fullscreen",
    fullscreenExit: "Fullscreen",
    programme: "Programme",
    activation: "Activation",
    account: "Account",
    myAccount: "My Account",
    logout: "Log out",
    signInApple: "Sign in with Apple",
    signInGoogle: "Sign in with Google",
    results: "Results",
    schedule: "Daily schedule",
    matchplayPlayers: "Player search",
    matchplayLeaderboard: "Scoring",
    tennisplayerlocator: "Player locator",
    grid: "Grid",
    practiceRounds: "Practice Rounds",
    entrylist: "Entry List",
    groups: "Groups",
    practiceSessions: "Practice Sessions",
  },
  account: {
    error: "Sign-in failed. Please try again.",
    loginPrompt: "Log in or create an account",
  },
  slider: {
    round: "Round",
    information: "Information",
    playerSearch: "Player search",
    leaderboard: "Leaderboard",
    highlights: "Highlights",
    location: "Location",
    programme: "Programme",
    activation: "Activation",
    account: "Account",
    today: "Today",
    results: "Results",
    schedule: "Daily schedule",
    matchplayPlayers: "Player search",
    matchplayLeaderboard: "Scoring",
    tennisplayerlocator: "Player locator",
    tomorrow: "Tomorrow",
  },
  information: {
    "show-all-layers": "Show all layers",
    groups: "Groups",
    hole: "Holes",
    searchPlaceholder: "Search...",
    noPlaces: "No places available",
  },
  sort: {
    label: "Sort:",
    distance: "Distance",
    default: "Default",
    name: "Name (A-Z)",
  },
  programme: {
    searchPlaceholder: "Search...",
    noMatches: "No matches",
    noProgramme: "No programme available",
    addToCalendar: "Add to calendar",
  },
  leaderboard: {
    noDataAvailable: "There is no scoring data available yet.",
    projectedCut: "Projected Cut",
    noPlayersMatch: "No players match",
  },
  copyLink: {
    copy: "Copy link",
    copied: "Link copied",
    failed: "Couldn’t copy link",
    group: "Copy link to this group",
    player: "Copy link to this player",
  },
  leaderboardHeader: {
    pos: "Pos",
    name: "Name",
    par72: "Par 72",
    thru: "Thru",
    today: "Today",
    total: "Total",
    favorite: "Fav",
    tot: "Tot",
    score: "Score",
  },
  autocomplete: {
    player: "Name",
    tee: "Tee",
    thru: "Thru",
    group: "Group",
    placeholder: "Search player",
    noDataAvailable: "There is no draw data available yet.",
  },
  highlights: {
    noDataAvailable: "There are no highlights available yet.",
  },
  popupContent: {
    group: "Group",
    tee: "Tee",
    time: "Time",
    hole: "Hole",
    players: "Players",
    pos: "Pos",
    par: "Total",
    thru: "Thru",
    today: "Today",
  },
  popupContentMatchPlay: {
    round: "round",
    match: "match",
    hole: "hole",
  },
  playersOnThisArea: "Players currently on this area:",
  backToHome: {
    title: "Back to home",
  },
  zoomIn: {
    title: "Zoom in",
  },
  zoomOut: {
    title: "Zoom out",
  },
  location: {
    denied: {
      first: "You've decided not to share your position.",
      second:
        "But if you change your mind, please find below how to change it.",
    },
    unavailable:
      "The network is down or the location service can't be reached.",
    timeout: "The attempt timed out before it could get the location data.",
    error: "Geolocation failed due to unknown error.",
    "on-off": "How to turn GPS Location On/Off:",
    maxBound: {
      title: "Location",
      text: "You are currently outside the event location, we will display your position once you get closer to our location.",
    },
    android: {
      swipe: "Swipe down from the top of the screen.",
      touch: "Touch and hold Location",
      location: "If you don't find Location",
      edit: "Tap Edit",
      settings: "or Settings",
      drag: "Drag Location",
      quick: "into your Quick Settings",
    },
    apple: {
      settings: "Go to Settings",
      privacy: "Privacy",
      services: "Location Services.",
      location: "Make sure that Location Services is on.",
    },
  },
  info: {
    message: "3 Hole scoring - no live player data available.",
  },
  tennisEventTypeName: {
    MS: "Men Single",
    MD: "Men Double",
    QS: "Men Qualifier Single",
    QD: "Men Qualifier Double",
    LS: "Ladies Single",
    LD: "Ladies Double",
    RS: "Qualifier Ladies Single",
    RD: "Qualifier Ladies Double",
  },
  mapsearch: {
    placeholder: "Search map",
    sectionPlaces: "Places",
    sectionDrivers: "Drivers",
    sectionCars: "Cars",
    sectionPlayers: "Players",
  },
  crowdcloud: {
    busyLevelLow: "Low occupancy",
    busyLevelMedium: "Medium occupancy",
    busyLevelHigh: "High occupancy",
  },
  golf: {
    filters: {
      all: "All",
      playing: "Playing",
      practicing: "Practicing",
      favorites: "Favorites",
    },
    status: {
      teeTime: "Tee time",
      hole: "Hole",
      green: "Green",
      fairway: "Fairway",
      tee: "Tee",
      playing: "Playing",
      finished: "Finished",
      missedCut: "Missed Cut",
      retired: "Retired",
      withdrawn: "Withdrawn",
      disqualified: "Disqualified",
      didNotStart: "Did not start",
      unscheduled: "Unscheduled",
    },
    popup: {
      playerNotFound: "Player not found.",
    },
    scorecard: {
      noScores: "No scores recorded yet for this round.",
      hole: "Hole",
      out: "OUT",
      in: "IN",
      tot: "TOT",
      par: "Par",
      status: "Status",
      score: "Score",
      roundPrefix: "R",
    },
    hole: {
      par: "PAR",
      avgScore: "Avg. score:",
      tee: "Tee",
      green: "Green",
    },
    search: {
      noMatch: "No players match",
    },
    teeBox: {
      white: "White",
      yellow: "Yellow",
      blue: "Blue",
      red: "Red",
      orange: "Orange",
      green: "Green",
    },
    club: {
      waitingTeeTimes: "Waiting for tee time data...",
      groups: "groups",
      onCourse: "on course",
      fin: "Fin",
      group: "Group",
      groupsOnHole: "Groups on hole",
      pace: "Pace",
      paceOnSchedule: "On schedule",
      paceCongested: "Congested",
      paceSlow: "Slow",
      nineHoles: "9 holes only",
    },
    practice: {
      ended: "Practice ended",
      groupFinished: "Group finished",
      driving: "Driving",
      shortGame: "Short Game",
      putting: "Putting",
      moreSuffix: "more",
    },
    checkpoint: {
      whichGroup: "Which group are you in?",
      selectTeeTime: "Select your tee time to enable position tracking",
      empty: "Empty",
    },
    groupPlayersHint: "Click on any player to see the scorecard",
    scorecardTrailHint: "Click on any score to see the shot by shot trail",
    shotTrailHint: "Tap any numbered shot for details. Use the arrows to switch holes.\n✕ returns to the live map.",
    shotTrail: "Shot trail",
    shot: "shot",
    shots: "shots",
    noShotData: "no shot data yet",
    nextHole: "Next hole",
    previousHole: "Previous hole",
    matchplay: {
      tied: "TIED",
      allSquare: "A/S",
      active: "Active",
      selectToFind: "Select to find player:",
      squads: {
        USA: "U.S. Team",
        EUR: "Team EUR",
        INT: "Team INT",
      },
    },
  },
  tennis: {
    filters: {
      all: "All",
      favorites: "Favorites",
      liveMatches: "Live matches",
      singles: "Singles",
      doubles: "Doubles",
      qualifying: "Qualifying",
    },
    badges: {
      live: "Live",
      practicing: "Practicing",
      practice: "Practice",
      warmUp: "Warm-up",
      preMatch: "Pre-match",
      suspended: "Suspended",
      finished: "Finished",
      retired: "RET",
      defaulted: "DEF",
    },
    searchPlaceholder: "Search player...",
    noPlayersFound: "No players found.",
    noPlayersAvailable: "No players available.",
    playerNotFound: "Player not found.",
    noMatchesScheduled: "No matches scheduled.",
    noMatchesForPlayer: "No matches for that player.",
    noMatchesToday: "No matches scheduled for today.",
    noResultsYet: "No results yet.",
    noMatchesInProgress: "No matches in progress",
    next: "Next",
    scheduled: "Scheduled",
    round: "Round",
    match: "Match",
    serving: "Serving",
    of: "of",
    versus: "vs",
    lastMatchToday: "Last match today",
    set: "Set",
    followedBy: "Followed by",
    previousMatch: "Previous match",
    nextMatch: "Next match",
    showMatch: "Show match",
    playersOnArea: "Players on this area",
    noPracticeSessions: "No practice sessions today.",
    liveCourt: {
      tiebreak: "Tiebreak",
      matchTiebreak: "Match tiebreak",
      game: "Game",
      break: "Break",
      gameSetMatch: "Game, set & match",
      catchingUp: "Catching up",
      changeOfEnds: "Change of ends",
      breakPoint: "Break point",
      setPoint: "Set point",
      matchPoint: "Match point",
      deuce: "Deuce",
      sets: "Sets",
      watch: "Watch",
      watchLarge: "Watch the court in a large view",
      watching: "Playing in the large view",
    },
    scheduleDays: {
      label: "Tournament days",
      today: "Today",
      yesterday: "Yesterday",
      tomorrow: "Tomorrow",
      playOver: "Play is over for today",
      orderOfPlay: "Order of play",
    },
  },
  motorsport: {
    allClasses: "All Classes",
    noResults: "No results available",
    awaitingTiming: "Awaiting timing data…",
    noActiveSession: "No active session",
    noResultsYet: "No results yet",
    overallGap: "Overall Gap",
    overallInterval: "Overall Interval",
    inPit: "In Pit",
    leader: "Leader",
    caution: "Caution",
    fromLap: "From lap",
    car: "Car",
    carShot: "Car shot",
    enlarge: "Enlarge",
    sponsor: "Sponsor",
    carClass: "Class",
    ordinalSuffix: "",
    columns: {
      pos: "POS",
      driver: "Driver",
      gap: "Gap",
      laps: "Laps",
      rank: "Rank",
      time: "Time",
      grid: "Grid",
      stnr: "STNR",
    },
    stats: {
      position: "Position",
      gap: "Gap",
      bestLap: "Best Lap",
      gridToRace: "Grid → Race",
      laps: "Laps",
      status: "Status",
      gridPosition: "Grid Position",
      qualifyingTime: "Qualifying Time",
    },
    status: {
      finished: "Finished",
      running: "Running",
    },
  },
  share: {
    button: "Share",
    tabShare: "Share website",
    tabApp: "Download app",
    appTitle: "Get the app",
    appText: "Scan a code with your phone’s camera to get the official app, or click a button to open the store.",
    appTextIos: "Tap the button to visit the App Store to download the app.",
    appTextAndroid: "Tap the button to visit the Play Store to download the app.",
    nativeShare: "Share…",
    downloadIos: "Download for iOS",
    downloadAndroid: "Download for Android",
  },
};
